/**
 * 상대 시간 포맷팅 유틸 (i18n 통합)
 *
 * CommentSection, TaskCardList 등에서 재사용되는 "방금 전", "5분 전", "2시간 전" 등을
 * 영어 msgid 기반으로 정의하고, i18n._(msg) 호출로 다국어 지원.
 */
import { I18n } from '@lingui/core';
import { msg } from '@lingui/macro';

/**
 * 상대 시간 문자열 생성
 * 예: "2 minutes ago", "3 hours ago", "5 days ago", "Jul 5"
 *
 * @param dateStr ISO 8601 또는 밀리초 timestamp
 * @param i18n I18n 인스턴스 (i18n._(msg) 호출용)
 * @returns 포맷된 상대 시간 문자열
 */
export function formatRelativeTime(dateStr: string | number, i18n: I18n): string {
  const now = Date.now();
  const d = typeof dateStr === 'string' ? new Date(dateStr).getTime() : dateStr;
  const diff = now - d;

  const min = Math.floor(diff / 60000);
  if (min < 1) {
    return i18n._(msg`just now`);
  }

  if (min < 60) {
    const minutes = min;
    return i18n._(msg`${minutes}m ago`);
  }

  const hr = Math.floor(min / 60);
  if (hr < 24) return i18n._(msg`${hr}h ago`);

  const day = Math.floor(hr / 24);
  if (day < 30) return i18n._(msg`${day}d ago`);

  // 30일 이상: "Month Day" 형식 (로케일별 표준)
  const date = new Date(d);
  return date.toLocaleDateString(i18n.locale || 'en-US', {
    month: 'short',
    day: 'numeric',
  });
}
